import API from "@/services/api";
import { ICreateAddressAPIParams, ICreateAddressParams, ICreateAddressSucessResponse, IModifyAddressAPIParams, IModifyAddressParams, IModifyAddressSucessResponse, IResPartnerAddress, IUpdateAddressAPIParams, IUpdateAddressParams, IUpdateAddressSucessResponse } from "../types/address";


enum Endpoints {
  FetchAddress = '/addresses/',
  SendAddress = '/contracts/:contractName/notification/'
}

const fetchAddress = () => {
  return new Promise<IResPartnerAddress[]>(async (resolve, reject) => {
    API.get<IResPartnerAddress[]>({
      endpoint: Endpoints.FetchAddress,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const createAddress = ({
  address,
  contractName,
  type
}: ICreateAddressParams) => {

  return API.post<ICreateAddressSucessResponse, ICreateAddressAPIParams>({
    endpoint: Endpoints.SendAddress,
    versions: [2],
    data: {
      address: address
    },
    searchParams: `?type=${type}`,
    params: {
      contractName
    }
  });
}

const updateAddress = ({
  addressId,
  contractName,
  type
}: IUpdateAddressParams) => {

  return API.put<IUpdateAddressSucessResponse, IUpdateAddressAPIParams>({
    endpoint: Endpoints.SendAddress,
    versions: [2],
    data: {
      addressId: addressId
    },
    searchParams: `?type=${type}`,
    params: {
      contractName
    }
  });
}

const modifyAddress = ({
  address,
  contractName,
  type
}: IModifyAddressParams) => {
  return API.put<IModifyAddressSucessResponse, IModifyAddressAPIParams>({
    endpoint: Endpoints.SendAddress,
    versions: [2],
    data: {
      address
    },
    searchParams: `?type=${type}`,
    params: {
      contractName
    }
  });
}

export default {
  fetchAddress,
  createAddress,
  updateAddress,
  modifyAddress
};


